/**
 * Kinesis config for the Dolphin analytics event stream, per user region.
 *
 * IDENTITY_POOL_ID also populates application.cognito_identity_pool_id in the
 * envelope, so credentials and payload cannot drift. LEGACY_APP_ID is the former
 * Pinpoint app id, still a filtered Redshift column (application_app_id), so it must
 * not change. STREAM_NAME "Dolphin_Event" is the stream each region's Pinpoint app
 * already delivers to, so writing directly reproduces today's behaviour.
 *
 * Each stream is drained by two Firehoses (3-month and 15-day Redshift tables) with
 * different JSONPaths/column orders. The envelope populates none of the differing
 * paths, and neither Firehose appends a delimiter, so the producer-side trailing
 * newline is load-bearing.
 */
export default {
    NA: {
        AWS_REGION: "us-east-1",
        IDENTITY_POOL_ID: "us-east-1:6b7aa5e1-583d-4a91-8d21-c2d3a337ade0",
        STREAM_NAME: "Dolphin_Event",
        LEGACY_APP_ID: "5e0cafc38eb2450da61e6ffadf092462"
    },
    FE: {
        AWS_REGION: "us-west-2",
        IDENTITY_POOL_ID: "us-west-2:2a51dd31-c80d-4c4a-aca3-eea45da3eaf3",
        STREAM_NAME: "Dolphin_Event",
        LEGACY_APP_ID: "bfd5efce28444d549a83fd92e98b8a79"
    },
    EU: {
        AWS_REGION: "eu-west-1",
        IDENTITY_POOL_ID: "eu-west-1:e3537bfb-117a-4792-b738-02b57ed8b433",
        STREAM_NAME: "Dolphin_Event",
        LEGACY_APP_ID: "63f5664869fb4e9483e6b954d858add6"
    }
};
